import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'antd';
import { fetchOCR } from '../../api/demonstration';
import FunctionDemonstration from './FunctionDemonstration';
import account from '@/common/account/index';

const OcrSsaDemonstration = ({ materialsPath }) => {
  const [result, setResult] = useState([]);
  const [response, setReponse] = useState(null);
  const [request] = useState({
    Params: {
      image: '图片的Base64编码',
      keywords: ['学而思', '网校', '学而思网校']
    }
  });

  function getBase64Image(img) {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, img.width, img.height);
    const ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
    const dataURL = canvas.toDataURL(`image/${ext}`);
    return dataURL;
  }

  const analysisImg = (imgBase64) => {
    const img = imgBase64.replace(/\S*base64,/, '');
    let userId = null;
    const loginEd = account.hasLoggedin();
    if (loginEd) userId = localStorage.getItem('userId') || null;
    fetchOCR({
      token: 'wangjinjun',
      sid: 'xueersi_ai_ocr_correct_calculation_all',
      image: img,
      keywords: ['学而思', '网校', '学而思网校'],
      method: '/aiocr/rescrshot',
      userId
    })
      .then((data) => {
        setReponse(data);
        if (data.code === 20001) {
          setResult(data.data.status);
        }
      })
      .catch((err) => {
        Message.error(err.msg || err.message);
        setReponse({});
        // console.log(err);
      });
  };

  const handleImgurlToBase64 = (imgurl) => {
    const image = new Image();
    image.src = imgurl;
    image.onload = () => {
      const imgBase64 = getBase64Image(image);
      analysisImg(imgBase64);
    };
  };

  const identifyingImg = (imgurl, imgBase64) => {
    if (imgurl) {
      handleImgurlToBase64(imgurl);
    } else if (imgBase64) {
      analysisImg(imgBase64);
    }
  };

  const handleResult = () => {
    switch (result) {
      case 3000:
        return '审核通过';
      case 3001:
        return '未找到关键字“学而思”、“网校”';
      case 3002:
        return '非完整截图';
      case 3003:
        return '非朋友圈截图';
      case 3004:
        return '非本人的朋友圈截图';
      case 3007:
        return '图片重复';
      case 30010:
        return '图像数据解析失败';
      default:
        return '未知错误';
    }
  };

  return (
    <FunctionDemonstration
      result={
        <ul>
          <li className="result_text">
            <span>{handleResult()}</span>
          </li>
        </ul>
      }
      response={response}
      request={request}
      handleIdentifyingImg={identifyingImg}
      materialsPath={materialsPath}
    />
  );
};

OcrSsaDemonstration.propTypes = {
  data: PropTypes.shape({
    materialsPath: PropTypes.array
  })
};

export default OcrSsaDemonstration;
